import {
	Card,
	CardHeader,
	CardBody,
	withFilters,
	Button,
} from '@wordpress/components';
import { RawHTML } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { download } from '@wordpress/icons';

export const Promo = withFilters( 'popper.settings.promo' )( ( props ) => {
	const { message } = props;
	return (
		<Card>
			<CardHeader>
				<b>{ __( 'Popper PRO', 'popper' ) }</b>
			</CardHeader>

			<CardBody>
				<RawHTML>{ message }</RawHTML>
				<Button
					variant="primary"
					href="https://www.francescopepe.com/products/popper-pro/"
					icon={ download }
					iconPosition={ 'right' }
					target="_blank"
				>
					{ __( 'Try it now FREE!', 'popper' ) }
				</Button>
			</CardBody>
		</Card>
	);
} );
